import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setFilter } from "../../store/pointsSlice";
import "./WasteGroups.css";

const WasteGroups = () => {
    const dispatch = useDispatch();
    const points = useSelector((state) => state.points.points);
    const filteredPoints =
        useSelector((state) => state.points.filteredPoints) || [];
    const currentGroup = useSelector((state) => state.points.filters.group);

    const handleGroupToggle = (groupId) => {
        if (currentGroup === groupId) {
            dispatch(setFilter({ group: "" }));
            return;
        }

        if (currentGroup === "") {
            const oppositeGroup = groupId === "mining" ? "mining" : "alkaline";
            dispatch(setFilter({ group: oppositeGroup }));
            return;
        }
        if (currentGroup === "all") {
            const oppositeGroup = groupId === "mining" ? "alkaline" : "mining";
            dispatch(setFilter({ group: oppositeGroup }));
            return;
        }

        dispatch(setFilter({ group: "all" }));
    };

    const wasteGroups = React.useMemo(
        () => [
            {
                id: "mining",
                type: "Отходы горнодобычи",
                filteredObjects: filteredPoints.filter(
                    (p) => p.group === "mining"
                ).length,
            },
            {
                id: "alkaline",
                type: "Щелочные индустриальные отходы",
                filteredObjects: filteredPoints.filter(
                    (p) => p.group === "alkaline"
                ).length,
            },
        ],
        [filteredPoints]
    );

    const oppositeId = (id) => (id === "mining" ? "alkaline" : "mining");

    return (
        <div className="waste-groups">
            {wasteGroups.map((waste) => (
                <div
                    key={waste.id}
                    className={`waste-group-card ${
                        currentGroup === "all" || currentGroup === waste.id
                            ? "active"
                            : ""
                    } ${waste.id}`}
                >
                    <label className="waste-group-header">
                        <input
                            type="checkbox"
                            checked={
                                currentGroup === "all" ||
                                currentGroup === waste.id
                            }
                            onChange={() => handleGroupToggle(waste.id)}
                            className="waste-group-checkbox"
                        />
                        <span className="checkbox-text">{waste.type}</span>
                    </label>
                    <div className="waste-stats">
                        <div className="stat">
                            <span className="stat-value">
                                {waste.filteredObjects}
                            </span>
                            <span className="stat-label">объектов</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default WasteGroups;
